<template>
  <b-row>
    <b-col>
      <!-- SEARCH Autocomplete -->
      <!-- <b-row> -->
        <!-- <md-autocomplete v-model="selected" class="mo-autocomplete" md-layout="box" :md-options="placesPredictions" @md-changed="getPlacePredictions" @md-selected="getPlaceDetails">
          <label>Update location</label>

          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.description }}</template>
        </md-autocomplete> -->
      <!-- </b-row> -->
      <adr-search-bar
        :onPlaceSelected="getPlaceDetails"
        keywordPlaceholder="Address"
        :onError="searchError"
        searchType="address"
        :selected="selected">
      </adr-search-bar>
      <b-row>
        <b-col lg="6" md="6" sm="12" cols="12" class="pt-2">
            <b-row :class="{greyedOutContainer:!showPlaceDetails}" class="address-result-container" style="heigh: 270px">
              <!--  ADDRESS -->
              <md-card md-with-hover>
                <md-ripple>
                  <md-card-header>
                    <div class="md-title">Confirm location</div>
                    <div class="md-subhead">Add apartment number (optional)</div>
                  </md-card-header>

                  <md-card-content>
                    <p>{{selectedPlace.address.county}}, {{selectedPlace.address.municipality}}</p>
                    <p></p>
                    <p>{{selectedPlace.address.street}} {{selectedPlace.address.number}}</p>
                    <span></span>

                    <md-field style="color: #0069d9">
                      <label>Add apartment</label>
                      <md-input v-model="apartmentNumber"></md-input>
                    </md-field>
                  </md-card-content>

                  <md-card-actions >
                    <md-button :disabled="disableNext" v-if="!loadingPlaceDetails" @click="confirmLocation" style="color: #0069d9">Confirm</md-button>
                    <md-button disabled v-else style="color: #0069d9">loading...</md-button>
                  </md-card-actions>
                </md-ripple>
              </md-card>
            </b-row>
        </b-col>
        <b-col lg="6" md="6" sm="12" cols="12">
          <div class="map-container">
            <gmap-map ref="mymap" :center="mapStartLocation" :zoom="17" style="width: 100%; min-height: 270px">
               <gmap-marker v-if="!loadingPlaceDetails" :position="mapStartLocation"/>
            </gmap-map>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
  let emptySelectedPlace = {
    address:{
      county: '',
      municipality: '',
      street: '',
      number: '',
    },
    location: {lat: 59.0000, lng:24.0000}
  }
  import {
    Validator
  } from 'vee-validate'
  import {
    getPlacePredictions,
    getPlaceDetails
  } from '../mapsRepository.js'
  import { getLocation } from '../platform/location/services/locationService'
  import AddressSearchBar from '../components/adrSearchBar.vue';

  export default {
    props: {
      existingLocation:{
        type: Object,
        required: false
      },
      confirmLocationCallback:{
        type: Function,
        required: true
      }
    },
    components: {
        'adr-search-bar': AddressSearchBar
    },
    data() {
      return {
        loading: false,
        placesPredictions: [],
        selectedPlace: emptySelectedPlace,
        selected: '',
        apartmentNumber: '',
        loadingPlaceDetails: true,
        showPlaceDetails: false,
        disableNext: true,
        mapStartLocation: {lat: 59.0000, lng:24.0000},
      }
    },
    computed: {
    },
    created(){
      if(this.existingLocation){
        this.mapLocationToForm(this.existingLocation)
      }
    },
    methods: {
      searchError(error){
        this.$notify({
          title: "Something is not right",
          message: "Search is not working"
        })
      },
      mapLocationToForm(location){
        try{
          this.selected = location.address.county + ', ' + location.address.street + ', ' + location.address.number
          this.selectedPlace = JSON.parse(JSON.stringify(location))
          if(location.geoCoords[0]) this.mapStartLocation = {lat: parseFloat(location.geoCoords[0].lat), lng: parseFloat(location.geoCoords[0].lng)} 
          this.apartmentNumber = location.address.apartNumber
          this.showPlaceDetails = true
          this.loadingPlaceDetails = false
          this.disableNext = false
        }catch(err){
        }
      },
      getPlacePredictions(searchTerm){
        try{
          let searhTermForUrl = searchTerm.replace(new RegExp(' ', 'g'), '+');
          this.placesPredictions = getPlacePredictions(searhTermForUrl, 'address')
            .then(predictions => {
              return predictions
            })
            .catch(err => {
              return []
            })
        }catch(error){}
      },
      getPlaceDetails(item){
        this.loadingPlaceDetails = true
        this.showPlaceDetails = true
        this.disableNext = true
        this.selected = item.description
        let placeId = item.place_id
        getPlaceDetails(placeId)
          .then(details => {
            this.selectedPlace = this.createSelectedPlace(details)
            if(this.selectedPlace.geoCoords[0]) this.mapStartLocation = {lat: parseFloat(this.selectedPlace.geoCoords[0].lat), lng: parseFloat(this.selectedPlace.geoCoords[0].lng)} 
            this.loadingPlaceDetails = false
            this.disableNext = false
          })
          .catch(err => {
            this.loadingPlaceDetails = false
          })
      },
      createSelectedPlace(googPlaceDetails){
        try{
          let number=''
          let street=''
          let municipality=''
          let county=''
          let country=''

          let googAdrComponents = googPlaceDetails.address_components
          for(let component of googAdrComponents){
            if(component.types.indexOf('street_number') >= 0){
              number = component.short_name
            }
            if(component.types.indexOf('route') >= 0){
              street = component.short_name
            }
            if(component.types.indexOf('locality') >= 0){
              municipality = component.short_name
            }
            if(component.types.indexOf('administrative_area_level_1') >= 0){
              county = component.short_name
            }
            if(component.types.indexOf('country') >= 0){
              country = component.long_name
            }
          }

          return {
             address:{
               country:country,
               county: county,
               municipality: municipality,
               street: street,
               number: number,
               apartNumber: -1,
             },
             geoCoords:[ googPlaceDetails.geometry.location]
           }
        }catch(err){
          return emptySelectedPlace
        }
      },
      async confirmLocation() {
        // if(this.selectedPlace.address.street && this.selectedPlace.address.street != '' && this.selectedPlace.address.number != ''){
        //   this.loadingPlaceDetails = true
        //   this.selectedPlace.address.apartNumber = this.apartmentNumber
        //   var googleLocation = this.createGoogLocation(this.selectedPlace)
        //
        //   let request = this.createLocationRequest(this.selectedPlace)
        //   getLocation(request)
        //     .then(location => {
        //       this.confirmLocationCallback(location, googleLocation)
        //       this.loadingPlaceDetails = false
        //     })
        // }else{
        //   this.notifyError('Specify location', 'Include street & building')
        //   this.loadingPlaceDetails = false
        // }
        try {
            this.loadingPlaceDetails = true;
            const { address: { street, number: streetNumber, municipality: city } = {} } = this.selectedPlace;
            if (!city || !street || !streetNumber) {
                this.notifyError('Specify location', 'Include city, street and building');
                return;
            }
            // TODO: extract to a separate method?
            try {
                const propertyAlreadyExists = await this.$store.dispatch('checkPropertyAddress', {
                    city,
                    street,
                    streetNumber,
                    apartmentNumber: this.apartmentNumber || null,
                });
                if (propertyAlreadyExists) {
                    this.notifyError('Property address check', 'Property with chosen address already exists');
                    return;
                }
            }
            catch (error) {
                this.notifyError('Property address check error', 'Cannot check property address at the moment');
                console.error(error);
                return;
            }

            this.selectedPlace.address.apartNumber = this.apartmentNumber;
            const googleLocation = this.createGoogLocation(this.selectedPlace);
            const request = this.createLocationRequest(this.selectedPlace);
            getLocation(request)
                .then(location => {
                    this.confirmLocationCallback(location, googleLocation);
                    this.loadingPlaceDetails = false;
                })
        }
        catch (error) {
            this.notifyError('Property location error', 'Cannot determine property location at the moment');
        }
        finally {
            this.loadingPlaceDetails = false;
        }
      },
      createLocationRequest(selectedPlace){
        let request = {
          address:{
            county: selectedPlace.address.county,
            municipality: selectedPlace.address.municipality,
            street: selectedPlace.address.street,
            number: selectedPlace.address.number,
            apartNumber: selectedPlace.address.apartNumber
          }
        }
        return request
      },
      createGoogLocation(selectedPlace){
        let muni = this.getMuniWithoutExtras(selectedPlace.address.municipality)
        return{
          aal1: selectedPlace.address.county,
          locality: muni
        }
      },
      getMuniWithoutExtras(municipality){
        let muni = municipality
        try{
          let indexOfVald = municipality.toLowerCase().indexOf('vald')
          if(indexOfVald !== -1) muni = muni.substring(-1, indexOfVald).trim();
          return muni
        }catch(err){}
        return municipality
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      }
    }
  }
</script>
<style scoped>
  @import '../assets/styles/global.css';

</style>



// WEBPACK FOOTER //
// src/components/locationSearch.vue